import { action, observable, makeObservable } from 'mobx';
import {contentLoaders, SuccessResponse, X3LevelUpdateModel} from '../../../../domain';
import {HttpPromiseState, SaveStateHolder, StringControl, validators} from '../../../../lib/helpers';

export class AddLevelStore implements SaveStateHolder {
  name: StringControl;

  @observable.ref
  save: HttpPromiseState<SuccessResponse> | null;

  constructor(readonly ageCategoryId: number) {
    makeObservable(this);
    this.name = new StringControl('name', '', validators.required);
    this.save = null;
  }

  @action
  complete() {
    if (this.save?.isPending === true)
      return;
    this.name.markTouched();
    if (this.name.invalid)
      return;
    const model: X3LevelUpdateModel = {
      AgeCategoryId: this.ageCategoryId,
      Name: this.name.value
    };
    this.save = contentLoaders.x3level.insert(model);
  }
}
